import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import SuperSku from './SuperSku';
import { TConfiguratorOption } from '../_propTypes';

const SuperSkuContainer = ({ renderOptions, options }) => {
  return (
    <QueryProvider cacheKey="super_sku_product">
      <SuperSku renderOptions={renderOptions} options={options} />
    </QueryProvider>
  );
};

SuperSkuContainer.propTypes = {
  options: PropTypes.objectOf(TConfiguratorOption).isRequired,
  renderOptions: PropTypes.func.isRequired,
};

export default SuperSkuContainer;